import React, { useEffect, useState } from "react";
import styles from "./cookie-banner.module.scss";

const CONSENT_KEY = "cookieConsent";

const CookieBanner: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(CONSENT_KEY);
    if (!stored) setVisible(true);

    const onOpenPolicy = () => setVisible(true);
    window.addEventListener("open-cookie-banner", onOpenPolicy as EventListener);
    return () => window.removeEventListener("open-cookie-banner", onOpenPolicy as EventListener);
  }, []);

  const accept = () => {
    localStorage.setItem(CONSENT_KEY, "accepted");
    setVisible(false);
  };
  const reject = () => {
    localStorage.setItem(CONSENT_KEY, "rejected");
    setVisible(false);
  };
  const moreInfo = () => {
    window.dispatchEvent(new CustomEvent("open-cookie-modal"));
  };

  if (!visible) return null;

  return (
    <div className={styles.banner} role="dialog" aria-live="polite">
      <div className={styles.text}>
        <strong>Cookies</strong>
        <p>
          Wij gebruiken cookies om de website goed te laten werken en uw ervaring te verbeteren. Met "Accepteren" gaat u akkoord met functionele cookies. U kunt uw keuze later aanpassen.
        </p>
      </div>
      <div className={styles.actions}>
        <button className={styles.secondary} onClick={reject}>Weigeren</button>
        <button className={styles.primary} onClick={accept}>Accepteren</button>
        <button className={styles.link} onClick={moreInfo}>Meer info</button>
      </div>
    </div>
  );
};

export default CookieBanner;
